import { LoadIzzyMetadataEngine } from './custom/IzzyMetadataEngine.js';
import { LoadAPIKeyEntityExtended } from './custom/APIKeyEntityExtended.js';
import { LoadOrganizationSettingEntityExtended } from './custom/OrganizationSettingEntityExtended.js';
import { LoadChannelMessageEntityExtended } from './custom/ChannelMessageEntityExtended.js';
import { LoadOrganizationEntityExtended } from './custom/OrganizationEntityExtended.js';
import { LoadOrganizationActionEntityExtendedClient } from './custom/OrganizationActionEntityExtended.js';

export * from './generated/entity_subclasses.js'

export * from './custom/IzzyMetadataEngine.js'
export * from './custom/ChannelEntityExtended.js'
export * from './custom/ChannelMessageEntityExtended.js'
export * from './custom/ChannelMessageSearch.js'
export * from './custom/TicketState.js'
export * from './custom/APIKeyEntityExtended.js'
export * from './custom/OrganizationSettingEntityExtended.js'
export * from './custom/OrganizationEntityExtended.js'
export * from './custom/OrganizationActionEntityExtended.js'
export * from './custom/ChannelActionConfiguration.js'
export * from './custom/TicketTimeline.js'
export * from './MessageConverters/BaseMessageConverter.js';
export * from './MessageConverters/BettyBotConverter.js';
export * from './MessageConverters/OpenAIConverter.js';

export * from './custom/IzzySingleMessage.types.js';

/**
 * This function is used to force the generated entities to be loaded. This is necessary because of the way that tree shaking works in webpack.
 * If you don't import this function and execute it, then the generated entities will not be included in the build. This is because the entities are not directly
 * referenced in this file, so webpack doesn't know that they are needed. By importing this function and calling it, webpack will include the generated entities
 * in the build.
 *
 * @export
 * @returns {void}
 * @example
 * import { LoadGeneratedEntities } from 'mj_core'
 * LoadGeneratedEntities()
 */
export function LoadGeneratedEntities() {
    LoadIzzyMetadataEngine();
    LoadAPIKeyEntityExtended();
    LoadOrganizationSettingEntityExtended();
    LoadChannelMessageEntityExtended();
    LoadOrganizationEntityExtended();
    LoadOrganizationActionEntityExtendedClient();
} 